import type { SelectOption } from '@components/Select/select.types';
import { Ionicons } from '@expo/vector-icons';
import { Pressable } from 'react-native';
import { SizableText, XStack, useTheme } from 'tamagui';
import { getSelectedOptions } from './multiSelect.utils';

interface MultiSelectChipsProps {
  options: SelectOption[];
  values: string[];
  onRemove: (value: string) => void;
}

export const MultiSelectChips = ({
  options,
  values,
  onRemove,
}: MultiSelectChipsProps): React.ReactNode => {
  const theme = useTheme();
  const selectedOptions = getSelectedOptions(options, values);

  if (selectedOptions.length === 0) {
    return null;
  }

  return (
    <XStack gap="$2" flexWrap="wrap">
      {selectedOptions.map((option) => (
        <Pressable key={option.value} onPress={() => onRemove(option.value)}>
          <XStack
            backgroundColor="$tertiary50"
            borderRadius="$true"
            paddingHorizontal="$3"
            paddingVertical="$1"
            alignItems="center"
            gap="$2"
          >
            <SizableText size="$2">{option.label}</SizableText>
            <Ionicons name="close" size={16} color={theme.color?.val} />
          </XStack>
        </Pressable>
      ))}
    </XStack>
  );
};
